import classNames from "classnames";
import { InputOtp } from "primereact/inputotp";
import { KeyboardEventHandler } from "react";
import { Controller, FieldValues } from "react-hook-form";

import { FormControllerProp } from "../form-controller-prop.interface";
import FormError from "../form-error/form-error";
interface InputControlProps<FieldsType extends FieldValues>
  extends FormControllerProp<FieldsType> {
  label?: string;
  className?: string;
  containerClassName?: string;
  disabled?: boolean;
  hint?: string;
  mask?: boolean;
  length?: number;
  integerOnly?: boolean;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement> | undefined;
}

export function InputOptControl<FieldsType extends FieldValues>({
  rules,
  label,
  control,
  name,
  className,
  containerClassName,
  disabled,
  hint,
  mask,
  length = 4,
  integerOnly = false,
  onKeyDown,
}: InputControlProps<FieldsType>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <div className={classNames("field mt-5", containerClassName)}>
          <label className="text-xs text-gray-500" htmlFor={field.name}>
            {label}
          </label>
          <InputOtp
            id={field.name}
            value={field.value}
            className={classNames({ "p-invalid": fieldState.error }, className)}
            onChange={(e) => field.onChange(e.value)}
            disabled={disabled}
            onKeyDown={onKeyDown}
            mask={mask}
            length={length}
            integerOnly={integerOnly}
          />
          {hint && <small className="text-gray-400 mb-1">{hint}</small>}
          {fieldState.error && <FormError error={fieldState.error} />}
        </div>
      )}
    />
  );
}

export default InputOptControl;
